export default {
  ONBOARDING_STEP_KEY: 'onboarding_current_step', // @deprecated мигрируется в ONBOARDING_PROGRESS
  ONBOARDING_PROGRESS: 'onboarding_progress'
}
